import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Hotkeys from 'react-hot-keys';

import Button from '@mui/material/Button';
import {styled} from '@mui/system';

import history from '../../helpers/history';
import HotKeyChip from './HotKeyChip';


const StyledBaseButton = styled(Link)({
    textDecoration: 'none'
});

const StyledLightButton = styled(Button)(({ theme }) =>({
    padding: '0 10px 0 10px',
    minWidth: 0,
    minHeight: 0,
    lineHeight: theme.custom.font.line_height,
    fontSize: theme.custom.font.medium
}));

const StyledLinkButton = styled(Button)(({ theme }) =>({
    color: theme.palette.primary.dark,
    fontSize: theme.custom.font.medium,
    padding: 0,
    minWidth: 0,
    textTransform: 'none',
    '&:hover': {
         background: 'none'
    }
}));

const StyledTextButton = styled(Button)(({ theme }) =>({
    fontSize: theme.custom.font.large,
    color: '#000000',
    fontWeight: 400,
    padding: 0,
    minWidth: 0,
    textTransform: 'none',
    '&:hover': {
         background: 'none'
    }
}));


class LinkButton extends React.Component {

    constructor(props) {
        super(props);
    }

    clickButton = () => {
        history.push(this.props.linkData);
    };

    render() {
        const ButtonLink = React.forwardRef((props, ref) => <StyledBaseButton {...props} ref={ref}/>);
        ButtonLink.displayName = 'LinkButton';
        const optional_attributes = {};
        if(this.props.dataBt){
            optional_attributes["data-bt"] = this.props.dataBt;
        }
        if(this.props.disabled){
            optional_attributes.disabled = true;
        }
        let ButtonComponent = Button;
        optional_attributes.variant = 'contained';
        if(this.props.linkStyle === "light"){
            ButtonComponent = StyledLightButton;
            optional_attributes.variant = 'text';
            optional_attributes.color = 'secondary';
        }
        if(this.props.linkStyle === "link"){
            ButtonComponent = StyledLinkButton;
            optional_attributes.variant = 'text';
            optional_attributes.color = 'secondary';
        }
        if(this.props.linkStyle === "text"){
            ButtonComponent = StyledTextButton;
            optional_attributes.variant = 'text';
            optional_attributes.color = 'secondary';
        }

        return (
            <span>
                <ButtonComponent
                    size="small"
                    {...optional_attributes}
                    component={ButtonLink}
                    to={this.props.linkData}
                >
                    {this.props.text}
                    {this.props.hotKey && <HotKeyChip hotKey={this.props.hotKey} />}
                </ButtonComponent>
                {this.props.hotKey && <Hotkeys keyName={this.props.hotKey} onKeyDown={this.clickButton} />}
            </span>
        );
    }
}


LinkButton.propTypes = {
    text: PropTypes.string,
    linkData: PropTypes.object,
    linkStyle: PropTypes.string,
    disabled: PropTypes.bool,
    hotKey: PropTypes.string,
    dataBt: PropTypes.string
};

export default LinkButton;
